import { Component, Inject, OnInit, forwardRef, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SuppliersComponent } from './suppliers.component';

@Component({
    template: '',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SupplierCreateRoutingComponent implements OnInit {

    constructor(
        @Inject(forwardRef(() => SuppliersComponent)) private parent: SuppliersComponent,
        private router: Router,
        private route: ActivatedRoute
    ) { }

    ngOnInit() {
        // Open the modal using the parent component's method
        const modalRef = this.parent.createSupplier();

        // When modal closes or is dismissed, navigate back to the parent route
        modalRef.result.then(
            () => this.navigateBack(),
            () => this.navigateBack()
        );
    }

    navigateBack() {
        this.router.navigate(['../'], { relativeTo: this.route });
    }
}
